import { AlertController } from 'ionic-angular/components/alert/alert-controller';
import { SPHApplication } from './../../shared/model/sph-license.model';
import { LicenseManagerService } from './../../shared/licensemanager-service/licensemanager.service';
import { Component, Input } from '@angular/core';
import { SPHLoggedInUser, SPHLicense } from '../../shared/shared';
import { NavParams, ViewController, ToastController } from 'ionic-angular';

@Component({
    selector: 'edit-license',
    templateUrl: 'edit-license.component.html'
})

export class EditLicenseComponent {
    private _user: SPHLoggedInUser;
    @Input() set user(user: SPHLoggedInUser) {
        this._user = user;
    }
    get user(): SPHLoggedInUser {
        return this._user;
    }

    private _license: SPHLicense;
    @Input() set license(license: SPHLicense) {
        this._license = license;
    }
    get license(): SPHLicense {
        return this._license;
    }

    private availableApplications: SPHApplication[] = [];

    constructor(private navParams: NavParams, private licenseManagerService: LicenseManagerService, private viewController: ViewController, private alertController: AlertController, private toastController: ToastController) {
        this.license = this.navParams.get('license');
        this.user = this.navParams.get('user');
        this.availableApplications = this.navParams.get('availableApplications');

        if (this.availableApplications === undefined) {
            this.loadApplications();
        }
    }

    public didTapSaveLicense() {
        if (this.license.applications.length <= 0) {
            const alert = this.alertController.create({
                title: 'Lizenz enhält keine App.',
                subTitle: 'Alle Lizenzen müssen mindestens eine App enthalten.',
                buttons: ['OK']
              });
            alert.present();
            return;
        }

        if (!(this.license.applications.filter( (e) => e.name === 'eproject' ).length > 0)) {
            this.license.onlyassigned = true;
            this.license.extrainfos = false;
        }

        this.licenseManagerService.patchLicense(this.license.id, this.license, this.user.jwt).subscribe((success) => {
            const toast = this.toastController.create({ message: 'Lizenz gespeichert!', duration: 3000 });
            toast.present();

            this.viewController.dismiss();
        },
        this.licenseManagerService.handleHttpError('Fehler beim Speichern!'));
    }

    public didTapAbort() {
        this.viewController.dismiss();
    }

    private loadApplications() {
        if (this.user !== undefined) {
            this.licenseManagerService.getApplications(this.user.jwt).subscribe((applications) => {
                this.availableApplications = applications;
            }, this.licenseManagerService.handleHttpError('Fehler bei Lizenzen-Abruf'));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/editLicenseComponent/edit-license.component.ts